<template>
  <div>
    <Loading v-if="initialLoad"></Loading>
    <Layout v-else>
      <div class="pt-4">
        <h2 style="font-weight: bold">Good Morning, {{ name }}</h2>
        <p style="font-size: 1.125rem; color: var(--gray-500)">
          Here what’s happening in your aggregator portal
        </p>
      </div>
      <Overview class="overview">
        <p slot="card-1-title">Total Pinpad Transaction Value</p>
        <h3 slot="card-1-val">
          ₦<ICountUp
            :delay="delay"
            :endVal="totalPinpadTransactionValue"
            :options="options"
            @ready="getPinpadValue"
          />
        </h3>
        <span slot="card-1-percent">
          +<ICountUp
            :delay="delay"
            :endVal="pinpadPercent"
            :options="options"
            @ready="getPinpadPercent"
          />%
        </span>
        <span slot="from" class="grey-color pl_4">from last month</span>

        <p slot="card-2-title">Total POS Transaction Volume</p>
        <h3 slot="card-2-val">
          <ICountUp
            :delay="delay"
            :endVal="totalPosTransactionVolume"
            :options="options"
            @ready="getPosValue"
          />
        </h3>
        <span slot="card-2-percent">
          +<ICountUp
            :delay="delay"
            :endVal="posPercent"
            :options="options"
            @ready="getPosPercent"
          />%
        </span>

        <p slot="card-3-title">Total Transfer Transaction Value</p>
        <h3 slot="card-3-val">
          ₦<ICountUp
            :delay="delay"
            :endVal="totalTransferTransactionValue"
            :options="options"
            @ready="getTransferValue"
          />
        </h3>
        <span slot="card-3-percent">
          +<ICountUp
            :delay="delay"
            :endVal="transferPercent"
            :options="options"
            @ready="getTransferPercent"
          />%
        </span>

        <p class="ellipsis" slot="card-4-earnings">
          Total Number of Accounts Opened
        </p>
        <h3 slot="card-4-val">
          <ICountUp
            :delay="delay"
            :endVal="totalAccountsOpened"
            :options="options"
            @ready="getAccountsValue"
          />
        </h3>
        <span slot="card-4-percent">
          +<ICountUp
            :delay="delay"
            :endVal="accountsPercent"
            :options="options"
            @ready="getAccountsPercent"
          />%
        </span>
      </Overview>
      <b-row class="pt-5 d-flex align-items-stretch">
        <b-col cols="6">
          <b-card class="rc-card">
            <p style="font-weight: bold; font-size: 1.125rem; margin-bottom: 0">
              Transaction History
            </p>
            <p>
              <!-- <span style="color: var(--gray-400)">Transaction Volume </span>  -->
              <!-- 20 - 26 Jan, 2021 -->
            </p>
            <span>Coming Soon</span>
            <img
              class="d-none"
              src="../assets/images/graph.png"
              alt=""
              style="width: 100%"
            />
          </b-card>
        </b-col>
        <b-col>
          <b-card class="rc-card" style="height: 100%">
            <p class="text-left" style="color: var(--gray-400)">
              Ratio of Active Agents
            </p>
            <vc-donut :sections="sections">
              <p class="active-agents">{{ activeAgents }}</p>
              <p class="total-agents">/{{ totalAgents }}</p>
            </vc-donut>
          </b-card>
        </b-col>
        <b-col>
          <b-card class="rc-card" style="height: 100%"></b-card>
        </b-col>
      </b-row>
    </Layout>
  </div>
</template>

<style scoped></style>

<script>
// @ is an alias to /src
import Donut from "vue-css-donut-chart";
import "vue-css-donut-chart/dist/vcdonut.css";
import Vue from "vue";
import Loading from "@/components/Loading.vue";
import Layout from "@/components/Layout.vue";
import Overview from "@/components/Overview.vue";
import { mapState, mapActions } from "vuex";
import ICountUp from "vue-countup-v2";
Vue.use(Donut);
export default {
  name: "Dashboard",
  components: {
    Loading,
    Layout,
    Overview,
    ICountUp,
  },
  data() {
    return {
      sections: [{ value: 0, color: "#34B53A" }],
    };
  },
  computed: {
    ...mapState({
      name: (state) => state.user.user.user.name,
      initialLoad: (state) => state.dashboard.initialLoad,
      delay: (state) => state.user.delay,
      options: (state) => state.user.options,

      totalPinpadTransactionValue: (state) =>
        state.dashboard.dashboardData.data.total_pinpad_transaction_value,

      totalPosTransactionVolume: (state) =>
        state.dashboard.dashboardData.data.total_pos_transaction_value,

      totalTransferTransactionValue: (state) =>
        state.dashboard.dashboardData.data.total_transfer_value,

      totalAccountsOpened: (state) =>
        state.dashboard.dashboardData.data.total_accounts_opened,

      pinpadPercent: (state) =>
        state.dashboard.dashboardData.data.percentage_increase.pinpad,

      posPercent: (state) =>
        state.dashboard.dashboardData.data.percentage_increase.pos,

      transferPercent: (state) =>
        state.dashboard.dashboardData.data.percentage_increase.transfer,

      accountsPercent: (state) =>
        state.dashboard.dashboardData.data.percentage_increase.account_opening,

      totalAgents: (state) =>
        state.dashboard.dashboardData.data.total_number_agents,

      activeAgents: (state) =>
        state.dashboard.dashboardData.data.total_active_agents,

      inActiveAgents: (state) =>
        state.dashboard.dashboardData.data.total_inactive_agents,
    }),
  },
  methods: {
    ...mapActions({
      dashboard: "dashboard/getDashboardData",
    }),
    getPinpadValue(instance) {
      const that = this;
      instance.update(that.totalPinpadTransactionValue);
    },
    getPosValue(instance) {
      const that = this;
      instance.update(that.totalPosTransactionVolume);
    },
    getTransferValue(instance) {
      const that = this;
      instance.update(that.totalTransferTransactionValue);
    },
    getAccountsValue(instance) {
      const that = this;
      instance.update(that.totalAccountsOpened);
    },
    getPinpadPercent(instance) {
      const that = this;
      instance.update(that.pinpadPercent);
    },
    getPosPercent(instance) {
      const that = this;
      instance.update(that.posPercent);
    },
    getTransferPercent(instance) {
      const that = this;
      instance.update(that.transferPercent);
    },
    getAccountsPercent(instance) {
      const that = this;
      instance.update(that.accountsPercent);
    },
    getRatio() {
      this.sections[0].value = (this.activeAgents / this.totalAgents) * 100;
    },
  },
  created() {
    document.title = "Dashboard | ReadyCash Aggregator Portal";
    this.dashboard().then(() => {
      this.getRatio();
    });
  },
};
</script>

<style></style>
